module.exports = __webpack_public_path__ + "static/media/STEP1.e30e54fe.png";